import classes from './ActiveItem.module.css';

import moment from 'moment/moment';

function ActiveItem({ eventData: event }) {
	const msActive = !!event.ms && !event.ms.empty;
	const klhActive = !!event.klh && !event.klh.empty;
	const showOne = msActive !== klhActive;
	const nothingActive =
		(!event.ms || event.ms.empty) && (!event.klh || event.klh.empty);

	const styles = showOne ? {} : { width: '45%' };

	return (
		<div className={classes['active-item-container']}>
			{klhActive && !nothingActive && (
				<div className={classes.itemContainer} style={styles}>
					<h1 className={classes.title}>
						{event.klh.epgName || event.klh.hebDesc}
					</h1>
					<div className={classes.eventTimes}>
						<h2>{moment(event.klh.startTime).format('HH:mm')}</h2>
						<h2>{moment(event.klh.endTime).format('HH:mm')}</h2>
					</div>
				</div>
			)}
			{msActive && !nothingActive && (
				<div className={classes.itemContainer} style={styles}>
					<h1 className={classes.title}>{event.ms.Subject}</h1>
					<div className={classes.eventTimes}>
						<h2>{moment(event.ms.startTime).format('HH:mm')}</h2>
						<h2>{moment(event.ms.endTime).format('HH:mm')}</h2>
					</div>
				</div>
			)}
			{nothingActive && !event.meetingRoom && (
				<div className={classes.itemContainer} style={styles}>
					<h1 className={classes.title}>ללא אירועים מתוכננים</h1>
					<div className={classes.eventTimes}></div>
				</div>
			)}
		</div>
	);
}

export default ActiveItem;
